/**
 * Which implementation of `DecisionTreeApi` the app uses.
 *
 * One place, so swapping the mock for the generated client is one edit here rather than a
 * search through the pages. The real one cannot be written yet: the nine operations are in
 * `SalesRecommendationHubModel` but not in `@amzn/salesrecommendationhub-client`, because the
 * model change has not been published to a version set.
 *
 * When it is, this becomes:
 *
 *   import { getCpaClient } from './CpaClient';
 *   import { PutDecisionTreeDraftCommand, ... } from '@amzn/salesrecommendationhub-client';
 *   class RealDecisionTreeApi implements DecisionTreeApi { ... }
 *
 * and the adapter is thin because `DecisionTreeApi`'s shapes were written to match the model.
 */
import type { DecisionTreeApi } from './treeApiTypes';
import { MockDecisionTreeApi, installMockHooks } from './MockDecisionTreeApi';

let api: DecisionTreeApi | null = null;

export function getDecisionTreeApi(treeId: string): DecisionTreeApi {
  if (!api) {
    api = new MockDecisionTreeApi();
    installMockHooks(treeId);
    // eslint-disable-next-line no-console
    console.info(
      '%c[CPA] 决策树用的是 MOCK API%c —— 状态在 localStorage。' +
        '控制台可用：__cpaMock.otherEditorOpens() / otherEditorCommits() / dump() / reset()',
      'background:#8a6116;color:#fff;padding:1px 6px;border-radius:3px;font-weight:600',
      'color:#5f6b7a',
    );
  }
  return api;
}

/** For tests, and for the switch to the real client. */
export function setDecisionTreeApi(next: DecisionTreeApi | null): void {
  api = next;
}
